import { combineReducers } from "redux";
import { user } from "./user.reducer";
import { runbook } from "./runbook.reducer";
import { client } from "./client.reducer";
import { runbookExecutionHistory } from "./runbookExecutionHistory.reducer";
import { runbookExecutionHistoryLine } from "./runbookExecutionHistoryLine.reducer";
import { dashboard } from "./dashboard.reducer";
import { scheduler } from "./scheduler.reducer";
import { signInHelp } from "./signInHelp.reducer";
import { invitation } from "./invitation.reducer";
import { settings } from "./settings.reducer";
import { clientVariable } from "./clientVariable.reducer";
import { runbookStep } from "./runbookStep.reducer";
import { clientConnector } from "./clientConnector.reducer";
import { clientVariableLine } from "./clientVariableLine.reducer";
import { broadcastMessage } from "./broadcastMessage.reducer";
import { broadcastMessageReview } from "./broadcastMessageReview.reducer";
import { runbookConnector } from "./runbookConnector.reducer";
import { runbookServer } from "./runbookServer.reducer";
import { runbookSystem } from "./runbookSystem.reducer";
import { emailDomainAuthenticator } from "./emailDomainAuthenticator.reducer";
import { runbookVersion } from "./runbookVersion.reducer";
import { runbookContact } from "./runbookContact.reducer";
import { auditLog } from "./auditLog.reducer";
import { analytics } from "./analytics.reducer";
import { azureCost } from "./azureCost.reducer";
import { mcpToken } from "./mcpToken.reducer";
import { inspectRequest } from "./inspectRequest.reducer";

export default combineReducers({
  user,
  runbook,
  client,
  runbookExecutionHistory,
  runbookExecutionHistoryLine,
  dashboard,
  scheduler,
  signInHelp,
  invitation,
  settings,
  clientVariable,
  runbookStep,
  clientConnector,
  clientVariableLine,
  broadcastMessage,
  broadcastMessageReview,
  runbookConnector,
  runbookServer,
  runbookSystem,
  emailDomainAuthenticator,
  runbookVersion,
  runbookContact,
  auditLog,
  analytics,
  azureCost,
  mcpToken,
  inspectRequest,
});
